(function () {
  'use strict';


  /*
   * ============================================================
   * COUNTRY SELECTOR
   * ============================================================
   *
   * IMPORTANT:
   *
   * The header country dropdown is handled by the theme's
   * native <popout-select> component.
   *
   * Therefore this file DOES NOT override:
   *
   * - [data-popout-toggle]
   * - [data-popout-option]
   * - theme dropdown opening
   * - theme dropdown submission
   *
   *
   * This file is only responsible for the automatic
   * geolocation country popup.
   *
   * ============================================================
   */


  /*
   * ============================================================
   * COUNTRY SELECTOR CUSTOM ELEMENT
   * ============================================================
   */

  class CountrySelector extends HTMLElement {


    constructor() {

      super();


      /*
       * Local storage key.
       */

      this.LOCAL_STORAGE_KEY =
        'COUNTRY_CHECKED';


      /*
       * Current Shopify country.
       */

      this.currentCountry =
        this.getAttribute(
          'data-current-country'
        );


      /*
       * Current Shopify language.
       */

      this.currentLanguage =
        this.getAttribute(
          'data-current-language'
        );


      /*
       * Existing GB -> UK mapping.
       */

      if (
        this.currentCountry === 'GB'
      ) {

        this.currentCountry = 'UK';

      }


      console.log(
        'Current country:',
        this.currentCountry
      );

    }



    /*
     * ============================================================
     * CONNECTED CALLBACK
     * ============================================================
     */

    connectedCallback() {


      /*
       * Prevent duplicate initialization.
       */

      if (
        this.dataset.initialized === 'true'
      ) {

        return;

      }


      this.dataset.initialized = 'true';


      /*
       * Check URL.
       */

      const url =
        new URL(
          window.location.href
        );


      /*
       * Country has already been selected.
       */

      if (
        url.searchParams.get(
          'country_selected'
        ) === 'true'
      ) {

        console.log(
          'Country already selected.'
        );


        this.setCountryChecked();


        return;

      }


      /*
       * Country has already been checked.
       */

      if (
        this.hasCountryBeenChecked()
      ) {

        console.log(
          'Country already checked.'
        );


        return;

      }


      /*
       * Setup popup interactions.
       */

      this.setupPopupHandlers();


      /*
       * Fetch visitor location.
       */

      this.fetchGeolocation();

    }



    /*
     * ============================================================
     * POPUP HANDLERS
     * ============================================================
     */

    setupPopupHandlers() {


      /*
       * Close button.
       */

      const closeButton =
        this.querySelector(
          '[data-popup-close]'
        );


      if (closeButton) {


        closeButton.addEventListener(
          'click',
          (event) => {

            event.preventDefault();
            event.stopPropagation();


            this.removeCountrySelector();


            this.setCountryChecked();

          }
        );


      } else {

        console.log(
          'Country popup close button not found.'
        );

      }


      /*
       * Overlay click.
       *
       * Do NOT close if clicking inside popup content.
       */

      this.addEventListener(
        'click',
        (event) => {


          const popupContent =
            event.target.closest(
              '.country-selector__content'
            );


          if (
            !popupContent
          ) {

            /*
             * Only close if the click happened on the
             * country-selector background/overlay.
             */

            if (
              event.target === this ||
              event.target.classList.contains(
                'popup-overlay'
              )
            ) {

              this.removeCountrySelector();

              this.setCountryChecked();

            }

          }

        }
      );

    }



    /*
     * ============================================================
     * GEOLOCATION
     * ============================================================
     */

    fetchGeolocation() {


      console.log(
        'Fetching geolocation data...'
      );


      fetch(
        'https://rebuyengine.com/api/v1/customers/geolocation?key=06c0934b6d04add29935a8b78521d404b0df5cf5'
      )


        .then(
          (response) => {

            if (
              !response.ok
            ) {

              throw new Error(
                'Geolocation request failed: ' +
                response.status
              );

            }


            return response.json();

          }
        )


        .then(
          (data) => {


            console.log(
              'Geolocation response:',
              data
            );


            if (
              !data ||
              !data.data
            ) {

              console.warn(
                'Invalid geolocation response.'
              );


              return;

            }


            const geo =
              data.data;


            /*
             * Check whether popup should be shown.
             */

            if (
              this.shouldShowPopup(
                geo
              )
            ) {


              console.log(
                'Showing country selector for:',
                geo.country_code
              );


              setTimeout(
                () => {

                  this.showCountrySelector();

                },
                1000
              );


            } else {


              console.log(
                'No country popup required.'
              );


              this.setCountryChecked();

            }

          }
        )


        .catch(
          (error) => {

            console.error(
              'Error in Country Locator:',
              error
            );

          }
        );

    }



    /*
     * ============================================================
     * CHECK DETECTED COUNTRY
     * ============================================================
     */

    shouldShowPopup(geo) {


      if (
        !geo ||
        !geo.country_code
      ) {

        return false;

      }


      let detectedCountry =
        geo.country_code;


      /*
       * Existing GB -> UK mapping.
       */

      if (
        detectedCountry === 'GB'
      ) {

        detectedCountry = 'UK';

      }


      /*
       * Different country?
       */

      if (
        detectedCountry !==
        this.currentCountry
      ) {


        console.log(
          'Different country detected:',
          detectedCountry
        );


        return true;

      }


      console.log(
        'Detected country matches current country.'
      );


      return false;

    }



    /*
     * ============================================================
     * SHOW POPUP
     * ============================================================
     */

    showCountrySelector() {


      this.classList.add(
        'show'
      );


    }



    /*
     * ============================================================
     * REMOVE POPUP
     * ============================================================
     */

    removeCountrySelector() {


      console.log(
        'Removing country selector.'
      );


      this.classList.remove(
        'show'
      );

    }



    /*
     * ============================================================
     * LOCAL STORAGE
     * ============================================================
     */

    hasCountryBeenChecked() {


      try {

        const checked =
          localStorage.getItem(
            this.LOCAL_STORAGE_KEY
          );


        console.log(
          'Has country been checked:',
          checked
        );


        return checked === 'true';

      } catch (error) {


        console.warn(
          'Unable to access localStorage:',
          error
        );


        return false;

      }

    }



    /*
     * ============================================================
     * SET COUNTRY CHECKED
     * ============================================================
     */

    setCountryChecked() {


      try {

        localStorage.setItem(
          this.LOCAL_STORAGE_KEY,
          'true'
        );

      } catch (error) {

        console.warn(
          'Unable to save country selection:',
          error
        );

      }

    }

  }



  /*
   * ============================================================
   * REGISTER CUSTOM ELEMENT
   * ============================================================
   */

  if (
    !customElements.get(
      'country-selector'
    )
  ) {

    customElements.define(
      'country-selector',
      CountrySelector
    );

  }

})();